import {useNavigate} from "react-router-dom"
import {Container} from "react-bootstrap";
import {Button} from "@mui/material";
import GppMaybeIcon from '@mui/icons-material/GppMaybe';

const Unauthorised = () => {

  const navigate = useNavigate();

  const goHome = () => navigate('/login');

  return (
    <Container>
      <div className="border rounded p-4 text-center">
        <h2><GppMaybeIcon style={{fontSize: '50px'}}/> Unauthorised</h2>
        <br/>
        <p>You do not have access permissions to the requested page.</p>
        <p>&nbsp;</p>
        <div className="flexGrow">
          <Button variant="contained" onClick={goHome}>Login</Button>
        </div>
      </div>
    </Container>
  )
}

export default Unauthorised